export default __webpack_public_path__ + "ban-circle-symbol.png";